import { palette } from './palette';

export const homeStyle = {
  /* Login -- Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },
        '& .section-header__title': {
          fontWeight: 400,
          fontSize: 32,
        },
        

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: `${palette.background.footer} !important`,
      color: palette.text.highlight,
      '&:hover': {
        backgroundColor: `${palette.background.footer} !important`,
        opacity: 0.9,
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .MuiButton-containedPrimary': {
      backgroundColor: `${palette.primary.main} !important`,
      color: palette.text.highlight, 
      '&:hover': {
        backgroundColor: palette.primary.main, 
        opacity: 0.9,
      },
    },
  },

  '.sandiegosmilecenter-container': {
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .hero-link-button': {
      // backgroundColor: `${palette.text.highlight} !important`,
      backgroundColor: palette.surface.light,
      color: palette.background.pricing,
      borderColor: palette.text.highlight,
      borderRadius: 0,
      '&:hover': {
        backgroundColor: palette.surface.light,
        color: palette.background.pricing,
        borderColor: palette.text.highlight,
      }
    },
    '& .login-button': {
      borderRadius: 0,
      backgroundColor: 'transparent',
      color: palette.text.highlight,
      border: `1px solid ${palette.text.highlight}`,
      '&:hover': {
        backgroundColor: 'transparent',
      color: palette.text.highlight,
      border: `1px solid ${palette.text.highlight}`,
      }
    },
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      backgroundColor: palette.background.pricing,
      color: palette.text.highlight,
      marginTop: 88,

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,

      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '68px',
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.hero1,
      width: '100vw',
      zIndex: 2,
      '& .section-alternate': {
        '& .section-alternate__content': {
          objectFit: 'contain',
          display: 'flex',
          justifyContent: 'center',
          '& .section-header__cta-wrapper': {
            display: 'flex',
            flexDirection: 'row',
            maxWidth: '90vw',
          },
          zIndex: 3,
        },
      },
      '& .MuiGrid-container': {
        width: 878,
        display: 'flex',
        justifyContent: 'center',
        '@media screen and (max-width: 900px)': {
          width: '100%',
        },
      },

      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.surface.header,
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
        '@media screen and (min-width: 2560px)': {
          objectFit: 'cover',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },

      '& .home-hero-title': {
        fontSize: 64,
        fontWeight: 400,
        justifyContent: 'center',
        textAlign: 'center',
        letterSpacing: '-1.28px',
        color: palette.text.highlight,
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Inter Display',
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      paddingBottom: '0px !important',
      backgroundColor: palette.background.benefits,
      '& .section-alternate__content': {
        padding: '48px 16px',
        '& .section-header__title': {
          color: `${palette.background.pricing} !important`,
          fontSize: 48,
          textAlign: 'left',
          fontWeight: 400,
          '&.MuiTypography-root': {
            fontWeight: '400 !important',
          },
          '&[class*="jss"]': {
            fontWeight: '400 !important',
          },
        },

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '& .definition-service-tile': {
          '@media (min-width: 600px)': {
            padding: '10px 24px',
          },
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
        '@media (max-width: 850px)': {
          display: 'grid !important',
          gridTemplateColumns: '1fr !important',
        },
      },
      '& .definition-services-grid .MuiGrid-item': {
        '@media (max-width: 850px)': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
      },
      '& .MuiCardContent-root': {
        padding: 32,
        borderRadius: 10,
        border: `1px solid ${palette.background.border}`,
        '@media (max-width: 600px)': {
          padding: '24px 24px',
        },
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 16,
      },
      '& .definition-service-title': {
        marginLeft: 16,
        fontWeight: 500,
        letterSpacing: '-0.32px',
        fontSize: 20,
        color: palette.text.primary,
      },
      '& .definition-service-description': {
        marginBottom: 0,
        color: palette.text.secondary,
        fontSize: 16,
        fontWeight: 400,
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
      },
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
      {
        color: `${palette.text.highlight} !important`,
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .customCardTitle': {
            fontWeight: 500,
            fontSize: 28,
          },
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: `${palette.text.primary} !important`,
            background: `${palette.text.highlight} !important`,
          },
          '& .MuiButton-outlinedSecondary': {
            borderColor: palette.primary.main,
            borderRadius: 0,
            color: `${palette.primary.main} !important`,
            '&:hover': {
              opacity: 1,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-title': {
        marginBottom: 40,
        fontWeight: 400,
        fontSize: 48,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.stepcounter,
        color: palette.text.content,
        fontSize: 15,
      },

      '& .working-steps-container': {
        '& .step-title': {
          fontSize: 20,
          fontWeight: 500,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .hero-home-button': {
        backgroundColor: 'transparent',
        color: palette.text.highlight,
        border: '1px solid ${palette.text.highlight}',
        borderRadius: 0,
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
          backgroundColor: palette.background.pricing,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        backgroundColor: palette.surface.grey,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.stepcounter} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.background.pricing,
        color: palette.text.highlight,
        borderRadius: 0,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: 32,
      },
      '& .section-header__subtitle': {
        color: palette.text.primary,
        fontWeight: 400,
        fontSize: 20,
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.background.pricing} !important`,
        borderColor: palette.primary.main,
        color: palette.secondary.main,
        fontWeight: 100,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.text.primary,
        }
      },
      '& .hero-home-button': {
        backgroundColor: 'transparent',
        color: palette.text.highlight,
        border: '1px solid ${palette.text.highlight}',
        borderRadius: 0,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.grey} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontWeight: 400,
        fontSize: 32,
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
      },
      '& .provider-contact-details': {
        fontSize: 16,
        color: palette.text.secondary,
      },
      '& .provider-contact-link': {
        fontSize: 20,
        fontWeight: 500,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: `${palette.background.footer} !important`,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: `${palette.background.footer} !important`,
          opacity: 0.9,
        },
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.primary,
      },
    },

    '& .footer-wrapper': {
      paddingInline: '20px !important',
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.primary,
        color: palette.background.primary,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.background.primary, // Common border color for all states

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.background.primary} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.primary,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.background.primary} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.background.primary,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        fill: `${palette.background.main} !important`, // Filled background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.primary, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.stepperCompleted} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      paddingInline: '20px !important',
    },
  },
};
